import { Card, CardHeader, CardHeading, Loading, useHasPermission } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { PermissionName } from "../../../shared/types/permission";
import { AppNotificationForm } from "../appNotifications/AppNotificationForm";
import { useAppNotification } from "../appNotifications/useAppNotification";
import { appNotificationService } from "../shared/api/appNotificationService";

export const AppNotificationUpdatePage: FC = () => {
	const { t } = useTranslation();
	const { appNotificationId = "" } = useParams();
	const { mapToValues, handleUpdate, handleDelete } = useAppNotification();
	const { data: appNotification, isLoading } = useQuery({
		queryKey: appNotificationService.showKey(appNotificationId),
		queryFn: () => appNotificationService.show(appNotificationId).then((response) => response.data.data),
	});
	const canDelete = useHasPermission<PermissionName>(["appNotification.delete"]);

	return (
		<Card>
			<CardHeader>
				<CardHeading>{t("Edit notification")}</CardHeading>
			</CardHeader>
			{isLoading && <Loading />}
			{appNotification && (
				<AppNotificationForm
					appNotification={mapToValues(appNotification)}
					handleSubmit={(values) => handleUpdate(appNotification.id, values)}
					disabled={["inProgress", "sent"].includes(appNotification.status)}
					handleDelete={canDelete ? () => handleDelete(appNotification.id) : undefined}
				/>
			)}
		</Card>
	);
};
